import { ICredentialsContext, IFilterValues } from './credentialsContext';

export enum CredentialsActionTypes {
	SET_CREDENTIALS = 'SET_CREDENTIALS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetCustomers {
	type: CredentialsActionTypes.SET_CREDENTIALS;
	payload: {
		credentials: ICredentialsContext['credentials'];
		typeOfModalWindow: ICredentialsContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: CredentialsActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: ICredentialsContext['searchString'];
	};
}

interface ISetSortBy {
	type: CredentialsActionTypes.SET_SORT_BY;
	payload: {
		sortBy: ICredentialsContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: CredentialsActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: ICredentialsContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: CredentialsActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: ICredentialsContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: CredentialsActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: ICredentialsContext['IDForDeletion'];
	};
}

interface IResetSelectedControls {
	type: CredentialsActionTypes.RESET_SELECTED_CONTROLS;
}

interface IChangeTypeOfModalWindow {
	type: CredentialsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICredentialsContext['typeOfModalWindow'];
	};
}

interface IShowErrorModalWithInfo {
	type: CredentialsActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: ICredentialsContext['errorResponseData'];
	};
}

interface ISetFiltersFromQueryString {
	type: CredentialsActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TCredentialsAction =
	| ISetCustomers
	| IChangeSearchString
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IResetSelectedControls
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| ISetFiltersFromQueryString;
